// Utility to get initial setting for lang/theme with priority: storage > URL param > fallback
export function getInitialSetting ({ key, urlParam, allowed, fallback }) {
  if (typeof window !== 'undefined') {
    // 1. Check storage
    const stored = localStorage.getItem(key)
    if (stored && allowed.includes(stored)) return stored

    // 2. Check URL param
    const params = new URLSearchParams(window.location.search)
    const urlValue = params.get(urlParam)
    if (urlValue && allowed.includes(urlValue)) return urlValue

    // 3. Fallback (system or default)
    if (typeof fallback === 'function') return fallback()
    return fallback
  }
  // SSR fallback
  if (typeof fallback === 'function') return fallback()
  return fallback
}
